import Scriba from 'react-scriba';

export const IDS_TYPE_MANDAT = {
    OPERATIONNEL: 1,
    COMMERCIALISATEUR: 2,
    CONTROLE_DE_GESTION: 3,
    GESTIONNAIRE_MANDAT: 4,
    WEB_SERVICES: 5,
    ADMINISTRATEUR: 6,
    DIRECTEUR_COMMERCIAL: 7,
    LECTEUR: 8,
    MAISON_INDIVIDUELLE: 9,
    EBOOK: 10,
    PRIMPROMO: 11,
    BACKOFFICECAPSULECLIENT: 12,
    CALLCENTER: 13,
    MODULEEXTERNE: 14,
    CONTROLEGESTIONNATIONAL: 15,
    CONTROLEGESTIONREGIONAL: 16,
    BACKOFFICEVENTE: 17,
    REPARTITEUR: 18
};

export class DataTypeMandat {

    // Note KP 17/03/2022 :
    // Si idTypeMandat === null alors charger tous les TypeMandat
    // Si idTypeMandat === IdTypeMandat.Commercialisateur || IdTypeMandat.WebServices alors charger TypeMandat correspondant
    // Si idTypeMandat === 0 alors charger tous les TypeMandat sauf IdTypeMandat.Commercialisateur et IdTypeMandat.WebServices
    // Si idTypeMandat === -1 alors charger tous les TypeMandat sauf IdTypeMandat.WebServices
    // A revoir / méthode contre-intuitive ?
    // KP - 2550 - 09/10/2023 : les valeurs 0 et -1 ont été remplacées ; on passe désormais une liste d'ids à exclure
    static _chargementTypeMandat = (idTypeMandat, listTypeMandatAExclure) => {
        const objet = { idTypeMandat, listTypeMandatAExclure };
        const url = "api/Liste/ListeDesTYPESMANDATS";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

};